// extracted by mini-css-extract-plugin
export default {"page":"styles_page__ClrVN","pageTransition":"styles_pageTransition__qI5Dc","content":"styles_content__D6CWE","footer":"styles_footer__GVIuo"};